"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConstantReference = void 0;
class ConstantReference {
  value() {
    return {
      type: "value",
      value: this.param.value
    };
  }
  constructor(param) {
    this.param = param;
  }
  get valueType() {
    return "value";
  }
  get variableType() {
    return "constant";
  }
  stop() {}
}
exports.ConstantReference = ConstantReference;
//# sourceMappingURL=ConstantReference.js.map